import {
      DELETE_PARTNER_INNOVATION,
      GET_PARTNER_INNOVATION_DETAILS,
      GET_PARTNER_INNOVATION_LIST,
      POST_PARTNER_INNOVATION,
      PUT_PARTNER_INNOVATION
    } from "../constants/actionTypes";
  
    const defaultState = {
      innovationProjectsWithPartnerInsitutionsArr:[],
      innovationProjectsWithPartnerInsitutionsDetails:{}
    };
  
    let data=[]
    export default (state = defaultState, action) => {
      try {
        switch (action.type) {
          case GET_PARTNER_INNOVATION_LIST:
            return {...state,innovationProjectsWithPartnerInsitutionsArr:[...action.payload]};
          case GET_PARTNER_INNOVATION_DETAILS:
            return {...state,innovationProjectsWithPartnerInsitutionsDetails:{...action.payload}};
          case POST_PARTNER_INNOVATION:
            return {...state,innovationProjectsWithPartnerInsitutionsDetails:[...state?.innovationProjectsWithPartnerInsitutionsArr,action.payload]};
          case PUT_PARTNER_INNOVATION:
            data = [...state?.innovationProjectsWithPartnerInsitutionsArr];
            const index = data?.findIndex(
              (setting) => setting?.id === action.payload?.id,
            );
            if (index != -1) data[index] = { ...action?.payload };
            return {...state,innovationProjectsWithPartnerInsitutionsArr: [...data]};
          case DELETE_PARTNER_INNOVATION:
            data = [...state?.innovationProjectsWithPartnerInsitutionsArr];
            const newData = data?.filter(
              (asset) => asset.id!=action.payload,
            );
            return {...state,innovationProjectsWithPartnerInsitutionsArr: [...newData]};
          default:
            return state;
        }
      } catch (error) {
        throw new Error(error);
      }
    };